import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useFormulaEvaluation = (recordId: string, fields: any[]) => {
  const [evaluatedData, setEvaluatedData] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!recordId || fields.length === 0) return;
    
    evaluateFormulas();
  }, [recordId, fields]);

  const evaluateFormulas = async () => {
    const formulaFields = fields.filter(f => f.type === "formula" && f.formula_expression);
    if (formulaFields.length === 0) return;

    setLoading(true);
    try {
      // Get the record data
      const { data: record, error: recordError } = await supabase
        .from("records")
        .select("data")
        .eq("id", recordId)
        .single();

      if (recordError) throw recordError;

      const results: Record<string, any> = {};
      
      // Evaluate each formula
      for (const field of formulaFields) {
        try {
          const { data, error } = await supabase.functions.invoke("evaluate-formula", {
            body: {
              formula: field.formula_expression,
              record: record.data,
              fields: fields
            }
          });

          if (error) {
            console.error(`Formula evaluation error for ${field.name}:`, error);
            results[field.name] = "Error";
          } else {
            results[field.name] = data.result;
          }
        } catch (err) {
          console.error(`Failed to evaluate formula for ${field.name}:`, err);
          results[field.name] = "Error";
        }
      }

      setEvaluatedData(results);
    } catch (error) {
      console.error("Formula evaluation failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return { evaluatedData, loading, refresh: evaluateFormulas };
};
